// extracted by mini-css-extract-plugin
module.exports = {"breakSmall":"767px","breakMedium":"1280px","logo":"Logo_logo__3IG6m","evelogo":"Logo_evelogo__1WHu_"};